<template>
    <!-- A relayer paid the network fee for this transfer. Hover on desktop, a tap on
         a phone opens and closes it; the tap also stops the row link from opening. -->
    <span class="tx-gasless-icon"
        v-on:mouseenter="onMouseEnter"
        v-on:mouseleave="showTooltip = false"
        v-on:click.stop.prevent="onClick"
    >
        <icon-badge-percent />
        <ui-tooltip v-if="showTooltip" v-bind:value="$t('address.tx_table.gasless_tooltip')" position="left" />
    </span>
</template>

<script>
import IconBadgePercent from '@img/icons/lucide/badge-percent.svg?vue';

const canHover = () => matchMedia('(hover: hover)').matches;

export default {
    data() {
        return {
            showTooltip: false,
        };
    },

    methods: {
        // A tap on a touch screen emulates mouseenter right before its click, which would
        // close the tooltip that has just opened; there the click alone toggles it:
        onMouseEnter() {
            if (canHover()) {
                this.showTooltip = true;
            }
        },

        onClick() {
            if (!canHover()) {
                this.showTooltip = !this.showTooltip;
            }
        },
    },

    components: {
        IconBadgePercent,
    },
};
</script>

<style lang="scss">
.tx-gasless-icon {
    position: relative;
    display: inline-flex;
    vertical-align: -2px;
    cursor: pointer;

    // The desktop row has no text beside it, it fills the comment icon's box:
    .tx-table-comment-icon & {
        vertical-align: top;
    }

    svg {
        width: 14px;
        height: 14px;
    }

    // Two lines, broken where the text says:
    .tip-tooltip-wrapper {
        width: max-content;
        white-space: pre-line;
    }
}
</style>
